import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, 'children'> {
  /** Element to render. Default `div`; use `li` inside a list, `section`/`article` for landmarks. */
  readonly as?: 'div' | 'section' | 'article' | 'li' | 'aside' | undefined;
  readonly children?: ReactNode;
}

/** Surface with a border and radius (`.dcs-card`, from `@dcs/ui/primitives.css`). */
export function Card({ as: Tag = 'div', className, children, ...rest }: CardProps) {
  return (
    <Tag className={className === undefined ? 'dcs-card' : `dcs-card ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
